import { Component, Input, Output, EventEmitter, HostListener, ElementRef, NgZone, ViewChild, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-calendar-shimmer-effect',
  templateUrl: './calendar-shimmer-effect.component.html',
})
export class CalendarShimmerEffectComponent {

}
